<template>
  <div class="page-view-container">
    <!-- 功能建设中空态页 -->
    <div v-if="isUnderConstructionPage" class="empty-state-container">
      <div class="empty-state">
        <div class="empty-state-icon-wrapper">
          <div class="empty-state-icon-bg"></div>
          <div class="empty-state-icon">
            <svg width="120" height="120" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M991.744 667.136h-14.848v14.848c0 8.192-6.656 14.848-14.848 14.848s-14.848-6.656-14.848-14.848v-14.848h-14.848c-8.192 0-14.848-6.656-14.848-14.848 0-8.192 6.656-14.848 14.848-14.848h14.848v-14.848c0-8.192 6.656-14.848 14.848-14.848s14.848 6.656 14.848 14.848v14.848h14.848c8.192 0 14.848 6.656 14.848 14.848 0 8.192-6.656 14.848-14.848 14.848zM407.552 118.272c-22.528 0-40.448-17.92-40.448-40.448s17.92-40.448 40.448-40.448 40.448 17.92 40.448 40.448-18.432 40.448-40.448 40.448z m12.288-60.928c-11.776-6.656-26.112-2.56-32.768 8.704-6.656 11.776-2.56 26.112 8.704 32.768 11.776 6.656 26.112 2.56 32.768-8.704s2.56-26.624-8.704-32.768zM54.784 261.12c-14.336 0-25.088-11.264-25.088-25.088 0-14.336 11.264-25.088 25.088-25.088s25.088 11.264 25.088 25.088c0.512 14.336-11.264 25.088-25.088 25.088zM582.144 236.032c0 7.68 6.144 13.312 13.312 13.312 7.68 0 13.312-6.144 13.312-13.312 0-7.68-6.144-13.312-13.312-13.312-7.168 0-13.312 5.632-13.312 13.312z" fill="#1890ff"></path>
              <path d="M636.928 950.784l-76.8-61.44c-1.536-1.536-3.072-4.096-3.072-6.656V823.296H399.36v59.904c0 2.56-1.024 5.12-2.56 6.144l-77.312 61.44c-6.656 6.144-9.216 15.36-6.144 23.552 3.584 8.192 11.264 13.824 19.968 13.824h288.768c8.704 0 16.896-5.632 19.968-13.824 4.096-8.192 2.048-17.408-5.12-23.552z m-116.224-64.512h-81.92 81.92z" fill="#ECECEC"></path>
              <path d="M623.104 998.912h-288.768c-13.312 0-24.576-8.192-29.696-20.48s-1.536-26.112 8.704-35.328l76.288-60.928V812.544h178.176v69.12l75.776 60.928c10.752 9.216 13.824 22.528 9.728 35.328-5.632 12.8-16.896 20.992-30.208 20.992z m-212.992-165.376v49.664c0 6.144-2.56 11.264-6.656 14.336l-77.312 61.44c-3.072 2.56-4.608 7.68-2.56 11.776 2.048 4.608 6.144 7.68 10.752 7.68h288.768c4.608 0 8.704-3.072 10.752-7.68 1.536-4.096 0-9.216-3.584-12.288L552.96 896.512c-3.584-3.584-6.144-8.704-6.144-13.824v-49.152h-136.704z m110.592 62.976h-92.16v-20.48h102.4v20.48h-10.24z" fill="#1890ff"></path>
              <path d="M851.456 415.744C811.008 415.744 778.24 382.976 778.24 342.528c0-21.504 9.216-40.96 24.064-54.272H77.312c-11.264 0-20.48 9.216-20.48 20.48v504.32c0 11.264 9.216 20.48 20.48 20.48h793.6c11.264 0 20.48-9.216 20.48-20.48V403.968c-11.264 7.168-25.088 11.776-39.936 11.776z" fill="#1890ff"></path>
              <path d="M848.896 415.744c-40.448 0-73.216-32.768-73.216-73.216 0-11.776 3.072-23.04 7.68-32.768H98.816c-11.264 0-20.48 9.216-20.48 20.48v404.992h791.552v-322.56c-6.656 2.048-13.824 3.072-20.992 3.072z m-183.808 103.936c0 2.56-1.536 4.096-4.096 4.096h-133.12c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h133.12c2.56 0 4.096 1.536 4.096 4.096z m-450.048 4.096c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h202.752c2.56 0 4.096 1.536 4.096 4.096s-2.048 4.096-4.096 4.096H215.04z m55.296 79.872c0 2.56-2.048 4.096-4.096 4.096h-102.4c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h101.888c2.56 0 4.608 1.536 4.608 4.096z m17.408-4.096h321.024c2.56 0 4.096 1.536 4.096 4.096s-2.048 4.096-4.096 4.096h-321.024c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096z m164.864-170.496h162.816c2.56 0 4.096 1.536 4.096 4.096s-2.048 4.096-4.096 4.096h-162.816c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096z m60.416 86.528c2.56 0 4.096 1.536 4.096 4.096s-2.048 4.096-4.096 4.096h-77.312c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h77.312zM400.896 429.056h27.136c2.56 0 4.096 1.536 4.096 4.096s-2.048 4.096-4.096 4.096h-27.136c-2.56 0-4.096-1.536-4.096-4.096s2.048-4.096 4.096-4.096zM275.456 364.032c-1.536-3.072-1.024-6.656 2.048-8.192 3.072-1.536 6.656-1.024 8.192 2.048l29.696 50.688-29.696 50.688c-1.024 1.536-3.072 3.072-5.12 3.072-1.024 0-2.048-0.512-3.584-1.024-3.072-1.536-4.096-5.632-2.048-8.192l25.6-44.032-25.088-45.056z m-78.848 92.16l45.568-100.864c1.024-3.584 5.12-4.608 8.192-3.584 3.584 1.024 4.608 5.12 3.584 8.192L208.384 460.8c-1.024 2.56-3.584 3.584-6.144 3.584-1.024 0-1.536 0-2.56-0.512-3.072-0.512-4.096-4.608-3.072-7.68z m-1.536 63.488c0 2.56-1.536 4.096-4.096 4.096H163.84c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h27.136c2.56 0 4.096 1.536 4.096 4.096zM163.84 357.888c1.536-3.072 5.632-4.096 8.192-2.048 3.072 1.536 4.096 5.632 2.048 8.192l-25.6 44.032 26.112 44.032c1.536 3.072 1.024 6.656-2.048 8.192-1.024 1.024-2.048 1.024-3.584 1.024-2.048 0-4.096-1.024-5.632-3.072l-29.696-50.688 30.208-49.664z m209.92 334.336h-222.208c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096H373.76c2.56 0 4.096 1.536 4.096 4.096s-1.536 4.096-4.096 4.096z m38.912 0h-20.48c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h20.48c2.56 0 4.096 1.536 4.096 4.096s-2.048 4.096-4.096 4.096z m240.128 0h-188.928c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h188.928c2.56 0 4.096 1.536 4.096 4.096s-2.048 4.096-4.096 4.096z m152.576 0h-126.464c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h126.464c2.56 0 4.096 1.536 4.096 4.096s-1.536 4.096-4.096 4.096z m0-83.968h-174.592c-2.56 0-4.096-1.536-4.096-4.096s1.536-4.096 4.096-4.096h174.592c2.56 0 4.096 1.536 4.096 4.096 0 2.048-1.536 4.096-4.096 4.096zM78.336 747.008v45.056c0 11.264 9.216 20.48 20.48 20.48h750.592c11.264 0 20.48-9.216 20.48-20.48v-45.056H78.336z m398.336 53.76c-10.24 0-18.432-8.192-18.432-18.432s8.192-18.432 18.432-18.432 18.432 8.192 18.432 18.432c0 9.728-8.192 18.432-18.432 18.432z" fill="#FBFBFB"></path>
              <path d="M1010.688 306.176c-0.512-10.24-8.192-17.92-18.432-17.92l-25.6-0.512c-6.144 0-12.288-3.584-15.36-8.704l-0.512-1.024c-3.584-5.632-4.096-12.288-1.536-17.92l10.752-23.04c4.096-9.216 0.512-19.968-8.192-24.576l-50.688-26.112c-8.704-4.608-19.968-1.024-25.088 7.168l-13.312 22.528c-3.584 5.632-9.216 8.704-15.36 9.216h-1.024c-6.656 0.512-12.8-2.56-16.384-7.68l-15.36-20.48c-6.144-8.192-16.896-10.24-25.088-4.608l-48.128 30.72c-8.192 5.12-11.264 15.872-6.144 25.088l12.8 22.528c3.584 6.144 3.584 12.8 0.512 18.432l-0.512 1.024c-3.072 5.632-8.192 9.216-14.848 10.24l-25.088 2.56c-10.24 1.024-17.408 9.216-16.896 19.456l2.56 57.344c0.512 10.24 8.192 17.92 18.432 17.92l25.6 0.512c6.144 0 12.288 3.584 15.36 8.704l0.512 1.024c3.584 5.632 4.096 12.288 1.536 17.92l-10.752 23.04c-4.096 9.216-0.512 19.968 8.192 24.576l50.688 26.112c2.56 1.024 5.632 2.048 8.192 2.048 6.656 0 12.8-3.584 16.384-9.728l13.312-22.528c3.584-5.632 9.216-8.704 15.36-9.216h1.024c6.656-0.512 12.8 2.56 16.384 7.68l15.36 20.48c6.144 8.192 16.896 10.24 25.088 4.608l48.128-30.72c8.192-5.12 11.264-15.872 6.144-25.088L955.904 414.72c-3.584-6.144-3.584-12.8-0.512-18.432l0.512-0.512c3.072-5.632 8.192-9.216 14.848-10.24l25.088-2.56c10.24-1.024 17.408-9.216 16.896-19.456l-2.048-57.344zM851.456 402.432c-33.28 0-59.904-27.136-59.904-59.904 0-33.28 27.136-59.904 59.904-59.904 33.28 0 59.904 27.136 59.904 59.904 0.512 32.768-26.624 59.904-59.904 59.904z" fill="#1890ff"></path>
              <path d="M851.456 342.016m-65.536 0a65.536 65.536 0 1 0 131.072 0 65.536 65.536 0 1 0-131.072 0Z" fill="#FFFFFF"></path>
            </svg>
          </div>
        </div>
        <div class="empty-state-content">
          <h3 class="empty-state-title">{{ emptyStateText }}</h3>
        </div>
        <div class="empty-state-decoration">
          <div class="decoration-dot decoration-dot-1"></div>
          <div class="decoration-dot decoration-dot-2"></div>
          <div class="decoration-dot decoration-dot-3"></div>
        </div>
      </div>
    </div>
    
    <!-- 正常列表页 -->
    <template v-else>
      <FilterContainer
        ref="filterContainer"
        :label-group="Number(labelGroup)"
        @search="handleFilterSearch"
        @reset="handleFilterReset"
        @advanced-search="handleAdvancedSearch"
      />
      <!-- PC端：表格展示 -->
      <DataTable
        v-if="!isMobile"
        :columns="tableColumns"
        :data="tableData"
        :total="total"
        :db-total-rows="dbTotalRows"
        :current-page="currentPage"
        :page-size="pageSize"
        :loading="loading"
        :export-loading="exportLoading"
        :label-group="Number(labelGroup)"
        @row-click="handleRowClick"
        @page-change="handlePageChange"
        @page-size-change="handlePageSizeChange"
        @export="handleExport"
      >
        <template #actions="{ record }">
          <a-button type="link" size="small" class="action-button" @click.stop="handleViewDetail(record)">
            查看详情
          </a-button>
        </template>
      </DataTable>
      <!-- 移动端：卡片列表展示 -->
      <MobileCardList
        v-else
        :columns="tableColumns"
        :data="tableData"
        :total="total"
        :db-total-rows="dbTotalRows"
        :page-size="pageSize"
        :loading="loading"
        @row-click="handleRowClick"
        @load-more="handleLoadMore"
        @view-detail="handleViewDetail"
      >
        <template #actions="{ record }">
          <a-button type="primary" size="small" class="mobile-card-action-btn" @click="handleViewDetail(record)">
            查看详情
          </a-button>
        </template>
      </MobileCardList>
    </template>
    
    <!-- 浮动筛选按钮 - 低分辨率屏幕快速访问 -->
    <a-button
      v-if="showFilterButton"
      type="primary"
      shape="circle"
      size="large"
      class="floating-filter-button"
      @click="scrollToFilter"
    >
      <Filter :size="20" />
    </a-button>
  </div>
</template>

<script>
import { Filter } from 'lucide-vue-next'
import { message } from 'ant-design-vue'
import FilterContainer from '../../components/filters/FilterContainer.vue'
import DataTable from '../../components/filters/DataTable.vue'
import MobileCardList from '../../components/filters/MobileCardList.vue'
import { getMarketList, getPoliciesList, getBiddingList, getNewTechList, getDeviceList, getClinicalList, postAdvancedSearch } from '../../api/filterApi'
import { createSearchExportTask } from '../../api/exportApi'
import { pollExportTask, downloadExportTaskFile } from '../../utils/exportTaskPoller'
import { getColumnsByLabelGroup as getColumnConfig, isUnderConstruction, getEmptyStateText, getPageMeta } from '../../utils/columnConfig'
import { PAGE_CONFIG_UPDATED } from '@/services/pageConfigService'
import { isMobileDevice } from '../../utils/deviceDetection'

export default {
  name: 'PageView',
  components: {
    Filter,
    FilterContainer,
    DataTable,
    MobileCardList
  },
  props: {
    labelGroup: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      tableColumns: [],
      tableData: [],
      currentFilters: {},
      total: 0,
      dbTotalRows: null,
      currentPage: 1,
      pageSize: 10,
      showFilterButton: false,
      loading: false,
      isMobile: false,
      mobileAllData: [], // 移动端累积的所有数据
      advancedSearchBody: null,
      exportLoading: false,
    }
  },
  created() {
    // 在 created 阶段就检测移动设备，确保初始渲染时就有正确的值
    this.checkMobile()
  },
  mounted() {
    this.checkMobile()
    // 确保在 mounted 时立即检查一次
    this.$nextTick(() => {
      this.checkMobile()
    })
    this.checkFilterVisibility()
    window.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener('resize', this.handleResize)
    // 给 #app 添加 min-width: auto !important
    const appElement = document.getElementById('app')
    if (appElement) {
      appElement.style.setProperty('min-width', 'auto', 'important')
    }
    this.onPageConfigUpdated = () => {
      this.tableColumns = this.getColumnsByLabelGroup(Number(this.labelGroup))
    }
    window.addEventListener(PAGE_CONFIG_UPDATED, this.onPageConfigUpdated)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true)
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener(PAGE_CONFIG_UPDATED, this.onPageConfigUpdated)
    // 移除 #app 的 min-width 样式
    const appElement = document.getElementById('app')
    if (appElement) {
      appElement.style.removeProperty('min-width')
    }
  },
  computed: {
    isUnderConstructionPage() {
      return isUnderConstruction(Number(this.labelGroup))
    },
    emptyStateText() {
      return getEmptyStateText(Number(this.labelGroup))
    }
  },
  watch: {
    labelGroup: {
      immediate: true,
      handler(newVal, oldVal) {
        // 如果 labelGroup 改变（切换菜单），清除旧的状态和筛选条件
        if (oldVal && oldVal !== newVal) {
          this.clearState()
          // 清除筛选条件状态
          if (this.$refs.filterContainer && this.$refs.filterContainer.clearFilterValues) {
            this.$refs.filterContainer.clearFilterValues()
          }
          // 关闭移动端筛选弹层
          if (this.$refs.filterContainer && this.$refs.filterContainer.$refs.mobileFilterContainer) {
            this.$refs.filterContainer.$refs.mobileFilterContainer.closeMenu()
            this.$refs.filterContainer.$refs.mobileFilterContainer.clearCommittedFilters()
          }
          // 重置筛选条件、高级检索、页码和总数
          this.currentFilters = {}
          this.advancedSearchBody = null
          this.currentPage = 1
          this.total = 0
          // 重置滚动位置
          this.resetScrollPosition()
        }
        // 正常切换 labelGroup 时不恢复状态，只在从详情页返回时恢复
        this.loadTableData(this.currentFilters)
      }
    }
  },
  activated() {
    // 组件被激活时，检查是否有保存的状态
    // 如果有保存的状态，说明是从详情页返回，恢复状态
    // 如果没有保存的状态，说明是切换菜单，不恢复
    const hasSavedState = this.hasSavedState()
    if (hasSavedState) {
      const savedScrollTop = this.restoreState()
      // 恢复后清除保存的状态，避免一直保存
      this.clearState()
      // 从详情页返回时，不需要重新加载数据，因为 keep-alive 已经保留了数据
      // 只需要恢复滚动位置即可
      if (savedScrollTop !== undefined) {
        this.$nextTick(() => {
          this.restoreScrollPosition(savedScrollTop)
        })
      }
    }
  },
  methods: {
    // 获取列配置（使用共享配置）
    getColumnsByLabelGroup(labelGroup) {
      return getColumnConfig(labelGroup)
    },
    // 将筛选条件对象转换为 search_params 数组格式（列表查询）
    convertFiltersToSearchParams(filters = {}) {
      const searchParams = []
      
      Object.keys(filters).forEach(key => {
        const value = filters[key]
        // 如果值为空字符串、null、undefined 或空数组，跳过
        if (value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
          return
        }
        
        // 如果值是字符串，转换为数组
        const valueArray = Array.isArray(value) ? value : [value]
        
        // 过滤掉空值
        const filteredValue = valueArray.filter(v => v !== '' && v !== null && v !== undefined)
        
        if (filteredValue.length > 0) {
          searchParams.push({
            key: key,
            value: filteredValue
          })
        }
      })
      
      return searchParams
    },
    /**
     * 导出接口要求 query.search_params 为字典（object），不能是数组
     * 无筛选时传 {} 作为默认参数
     */
    convertFiltersToExportSearchParams(filters = {}) {
      const params = {}
      Object.keys(filters || {}).forEach((key) => {
        const value = filters[key]
        if (value === '' || value === null || value === undefined) return
        if (Array.isArray(value)) {
          const filtered = value.filter((v) => v !== '' && v !== null && v !== undefined)
          if (filtered.length) params[key] = filtered
          return
        }
        params[key] = value
      })
      return params
    },
    async loadTableData(filters = {}, isLoadMore = false) {
      const labelGroupNum = Number(this.labelGroup)
      const searchParams = this.convertFiltersToSearchParams(filters)
      const params = this.buildListParams(searchParams)
      if (!isLoadMore) {
        this.loading = true
      }
      this.tableColumns = this.getColumnsByLabelGroup(labelGroupNum)

      const listFetchers = {
        1: getMarketList,
        2: getPoliciesList,
        3: getBiddingList,
        4: getNewTechList,
        5: getDeviceList,
        6: getClinicalList,
      }
      const fetchList = listFetchers[labelGroupNum]
      if (!fetchList && !(this.advancedSearchBody?.advance_query === 1)) {
        this.loading = false
        return
      }

      try {
        let response
        if (this.advancedSearchBody?.advance_query === 1) {
          response = await postAdvancedSearch(labelGroupNum, {
            ...this.advancedSearchBody,
            page: this.currentPage,
            limit: this.pageSize,
          })
        } else {
          response = await fetchList(params)
        }

        if (response.errno === 0) {
          let list = response.data?.list || []
          if (labelGroupNum === 6) {
            list = list.map((item) => {
              if (!item.study_type || !item.phase) {
                try {
                  const sourceData = typeof item.source_data === 'string'
                    ? JSON.parse(item.source_data)
                    : item.source_data
                  if (sourceData?.metadata) {
                    item.study_type = item.study_type || sourceData.metadata.studyType || ''
                    item.phase = item.phase || sourceData.metadata.phase || ''
                  }
                } catch (e) {
                  item.study_type = item.study_type || ''
                  item.phase = item.phase || ''
                }
              }
              return item
            })
          }
          if (this.isMobile && isLoadMore) {
            this.tableData = [...this.tableData, ...list]
          } else {
            this.tableData = list
          }
          this.total = response.data?.total || 0
          this.dbTotalRows = response.data?.db_total_rows
          this.currentPage = response.data?.page || 1
          this.pageSize = response.data?.limit || 10
        }
      } catch (error) {
        console.error('加载列表失败:', error)
        this.tableData = []
        this.total = 0
        this.dbTotalRows = null
      }

      this.loading = false
    },
    checkMobile() {
      this.isMobile = isMobileDevice()
    },
    handleResize() {
      this.checkMobile()
      this.checkFilterVisibility()
    },
    handleLoadMore(page) {
      // 移动端滚动加载更多
      this.currentPage = page
      this.loadTableData(this.currentFilters, true)
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadTableData(this.currentFilters)
    },
    handlePageSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadTableData(this.currentFilters)
    },
    handleFilterSearch(filters) {
      console.log('搜索筛选条件:', filters)
      this.advancedSearchBody = null
      this.currentFilters = filters
      // 重置页码为第一页
      this.currentPage = 1
      // 移动端重置累积数据
      if (this.isMobile) {
        this.tableData = []
      }
      // 根据筛选条件重新加载表格数据
      this.loadTableData(filters)
    },
    handleFilterReset(filters) {
      console.log('重置筛选条件:', filters)
      this.currentFilters = {}
      this.advancedSearchBody = null
      this.currentPage = 1
      if (this.isMobile) {
        this.tableData = []
      }
      this.loadTableData({})
    },
    handleAdvancedSearch(body) {
      this.advancedSearchBody = body
      this.currentPage = 1
      if (this.isMobile) {
        this.tableData = []
      }
      this.loadTableData(this.currentFilters)
    },
    buildListParams(searchParams) {
      return {
        search_params: searchParams,
        page: this.currentPage,
        limit: this.pageSize,
      }
    },
    buildExportPayload(columns) {
      const exportColumns = (columns || [])
        .filter((col) => col && col.key)
        .map((col) => ({
          key: col.key,
          title: col.title || col.label || col.key,
        }))

      const query = this.advancedSearchBody?.advance_query === 1
        ? {
            mode: 'advanced',
            conditions: Array.isArray(this.advancedSearchBody.conditions)
              ? this.advancedSearchBody.conditions
              : [],
          }
        : {
            mode: 'normal',
            // 导出接口要求 dict；无筛选时也要传默认空对象
            search_params: this.convertFiltersToExportSearchParams(this.currentFilters),
          }

      return {
        label_group: String(this.labelGroup),
        query,
        columns: exportColumns,
      }
    },
    async handleExport(columns) {
      if (this.exportLoading) return
      const payload = this.buildExportPayload(columns)
      if (!payload.columns.length) {
        message.warning('请至少选择一列后再导出')
        return
      }
      this.exportLoading = true
      let hideLoading = null
      try {
        hideLoading = message.loading('正在创建导出任务…', 0)
        const res = await createSearchExportTask(payload)
        const taskNo = res.data?.task_no
        if (!taskNo) {
          throw new Error('未返回任务编号')
        }
        hideLoading()
        hideLoading = message.loading('正在生成 Excel…', 0)
        await pollExportTask(taskNo)
        hideLoading()
        hideLoading = null
        await downloadExportTaskFile(taskNo)
        message.success('导出完成，开始下载')
      } catch (error) {
        if (hideLoading) hideLoading()
        if (!error?.response) {
          message.error(error?.message || '导出失败')
        }
      } finally {
        this.exportLoading = false
      }
    },
    handleRowClick(record) {
      console.log('点击行:', record)
    },
    handleViewDetail(record) {
      console.log('查看详情:', record)
      // 跳转详情页前，保存当前状态（包括筛选条件和分页）
      this.saveState()
      // 同时保存筛选容器的状态
      if (this.$refs.filterContainer && this.$refs.filterContainer.saveFilterValues) {
        this.$refs.filterContainer.saveFilterValues()
      }
      // 跳转到详情页，只传递 id，不传递数据
      const id = record.id || record.source_unique_id || Date.now()
      this.$router.push({
        name: 'Detail',
        params: {
          labelGroup: this.labelGroup,
          id: id
        }
      })
    },
    // 保存状态到 sessionStorage
    saveState() {
      const stateKey = `pageView_state_${this.labelGroup}`
      // 获取滚动位置
      let scrollTop = 0
      if (this.isMobile) {
        // 移动端：从移动端卡片列表的滚动容器获取
        const mobileScrollContainer = document.querySelector('.mobile-card-list-container')
        if (mobileScrollContainer) {
          scrollTop = mobileScrollContainer.scrollTop
        } else {
          // 降级：从 window 获取
          scrollTop = window.pageYOffset || document.documentElement.scrollTop
        }
      } else {
        // PC端：从 content-wrapper 或 window 获取
        const scrollContainer = document.querySelector('.content-wrapper')
        scrollTop = scrollContainer ? scrollContainer.scrollTop : (window.pageYOffset || document.documentElement.scrollTop)
      }
      
      const state = {
        currentFilters: this.currentFilters,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        total: this.total,
        scrollTop: scrollTop,
        isMobile: this.isMobile
      }
      try {
        sessionStorage.setItem(stateKey, JSON.stringify(state))
      } catch (error) {
        console.error('保存状态失败:', error)
      }
    },
    // 从 sessionStorage 恢复状态
    restoreState() {
      const stateKey = `pageView_state_${this.labelGroup}`
      try {
        const savedState = sessionStorage.getItem(stateKey)
        if (savedState) {
          const state = JSON.parse(savedState)
          this.currentFilters = state.currentFilters || {}
          this.currentPage = state.currentPage || 1
          this.pageSize = state.pageSize || 10
          this.total = state.total || 0
          
          // 如果保存的状态中有 isMobile，且与当前不一致，说明设备类型改变了，不恢复滚动位置
          // 但筛选条件等状态仍然恢复
          if (state.isMobile !== undefined && state.isMobile !== this.isMobile) {
            return undefined
          }
          
          // 返回保存的滚动位置，稍后恢复
          return state.scrollTop
        }
      } catch (error) {
        console.error('恢复状态失败:', error)
      }
      return undefined
    },
    // 恢复滚动位置
    restoreScrollPosition(scrollTop) {
      if (this.isMobile) {
        // 移动端：恢复到移动端卡片列表的滚动容器
        const mobileScrollContainer = document.querySelector('.mobile-card-list-container')
        if (mobileScrollContainer) {
          // 使用 $nextTick 确保 DOM 已渲染
          this.$nextTick(() => {
            mobileScrollContainer.scrollTop = scrollTop
          })
        } else {
          // 降级：使用 window 滚动
          this.$nextTick(() => {
            window.scrollTo(0, scrollTop)
          })
        }
      } else {
        // PC端：恢复到 content-wrapper 或 window
        const scrollContainer = document.querySelector('.content-wrapper')
        if (scrollContainer) {
          this.$nextTick(() => {
            scrollContainer.scrollTop = scrollTop
          })
        } else {
          this.$nextTick(() => {
            window.scrollTo(0, scrollTop)
          })
        }
      }
    },
    // 重置滚动位置
    resetScrollPosition() {
      if (this.isMobile) {
        // 移动端：重置移动端卡片列表的滚动容器
        const mobileScrollContainer = document.querySelector('.mobile-card-list-container')
        if (mobileScrollContainer) {
          this.$nextTick(() => {
            mobileScrollContainer.scrollTop = 0
          })
        } else {
          // 降级：使用 window 滚动
          this.$nextTick(() => {
            window.scrollTo(0, 0)
          })
        }
      } else {
        // PC端：重置 content-wrapper 或 window
        const scrollContainer = document.querySelector('.content-wrapper')
        if (scrollContainer) {
          this.$nextTick(() => {
            scrollContainer.scrollTop = 0
          })
        } else {
          this.$nextTick(() => {
            window.scrollTo(0, 0)
          })
        }
      }
    },
    // 清除状态
    clearState() {
      const stateKey = `pageView_state_${this.labelGroup}`
      try {
        sessionStorage.removeItem(stateKey)
      } catch (error) {
        console.error('清除状态失败:', error)
      }
    },
    // 检查是否有保存的状态
    hasSavedState() {
      const stateKey = `pageView_state_${this.labelGroup}`
      try {
        const savedState = sessionStorage.getItem(stateKey)
        return savedState !== null && savedState !== undefined
      } catch (error) {
        return false
      }
    },
   
    // 获取数据源名称
    getDataSource(labelGroup) {
      return getPageMeta(labelGroup).dataSource
    },
    getTitleField(labelGroup) {
      return getPageMeta(labelGroup).titleField
    },
    scrollToFilter() {
      // 滚动到筛选区域，考虑顶部导航栏高度（64px）
      const filterContainerRef = this.$refs.filterContainer
      if (!filterContainerRef) {
        return
      }
      
      // 获取 DOM 元素，可能是 $el 或者组件根元素
      const filterContainer = filterContainerRef.$el || filterContainerRef
      
      // 确保是有效的 DOM 元素
      if (!filterContainer || typeof filterContainer.getBoundingClientRect !== 'function') {
        return
      }
      
      // 如果是收起状态，先展开（仅PC端）
      if (filterContainerRef && !filterContainerRef.isMoreExpanded && !isMobileDevice()) {
        filterContainerRef.toggleExpand()
        // 等待展开动画完成后再滚动
        this.$nextTick(() => {
          this.scrollToElement(filterContainer)
        })
      } else {
        this.scrollToElement(filterContainer)
      }
    },
    scrollToElement(element) {
      this.$nextTick(() => {
        // 查找滚动容器（.content-wrapper）
        const scrollContainer = document.querySelector('.content-wrapper')
        
        if (element && scrollContainer) {
          // 获取元素和容器相对于视口的位置
          const containerRect = scrollContainer.getBoundingClientRect()
          const elementRect = element.getBoundingClientRect()
          
          // 计算目标滚动位置（元素顶部相对于容器的位置，减去一些偏移量）
          const offset = 16 // 顶部偏移量
          const targetScrollTop = scrollContainer.scrollTop + (elementRect.top - containerRect.top) - offset
          
          scrollContainer.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth'
          })
        } else if (element) {
          // 降级方案：如果没有找到滚动容器，使用 window 滚动
          const rect = element.getBoundingClientRect()
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop
          const targetPosition = rect.top + scrollTop - 64 // 64px 是顶部导航栏高度
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })
        }
      })
    },
    handleScroll() {
      this.checkFilterVisibility()
    },
    checkFilterVisibility() {
      // 检查筛选区域是否在可视区域内
      const filterContainerRef = this.$refs.filterContainer
      if (!filterContainerRef) {
        this.showFilterButton = false
        return
      }
      
      // 获取 DOM 元素，可能是 $el 或者组件根元素
      const filterContainer = filterContainerRef.$el || filterContainerRef
      
      // 确保是有效的 DOM 元素
      if (!filterContainer || typeof filterContainer.getBoundingClientRect !== 'function') {
        this.showFilterButton = false
        return
      }
      
      const rect = filterContainer.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth
      
      // 只在低分辨率屏幕（1366*768）和 pad 上显示，且不是移动端
      const isLowResolution = viewportWidth <= 1366 || viewportHeight <= 800
      const isMobile = isMobileDevice()
      
      if (!isLowResolution || isMobile) {
        this.showFilterButton = false
        return
      }
      
      // 筛选区域是否在可视区域内（考虑一些边距）
      const isVisible = rect.top >= -50 && rect.bottom <= viewportHeight + 50
      
      // 如果筛选区域不在可视区域内，显示按钮
      this.showFilterButton = !isVisible
    }
  }
}
</script>

<style scoped>
.page-view-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  margin: 0;
  padding: 0;
  max-width: 100vw;
}

@media (max-width: 767px) {
  .page-view-container {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

/* 浮动筛选按钮 */
.floating-filter-button {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s, transform 0.3s;
}

.floating-filter-button:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

/* 1366*768 和 pad 响应式优化 */
@media (max-width: 1366px) {
  .page-view-container {
    padding: 0;
  }
}

@media (max-width: 1024px) {
  .floating-filter-button {
    width: 48px;
    height: 48px;
    bottom: 16px;
    right: 16px;
  }
}

.action-button {
  padding: 0;
  height: auto;
  color: #1890ff;
}

.action-button:hover {
  color: #40a9ff;
}

/* 空态页样式 - 高大上版本 */
.empty-state-container {
  display: flex;
  align-items: center;
  justify-content: center;
  /* 使用 flex: 1 填充剩余空间，确保与正常列表页的布局一致 */
  flex: 1;
  min-height: 0;
  /* 四个方向使用相同的 padding，确保间距一致 */
  padding: 60px 24px;
  background: linear-gradient(135deg, #f0f5ff 0%, #ffffff 50%, #f0f5ff 100%);
  position: relative;
  overflow: hidden;
  /* 确保容器填满父元素高度 */
  box-sizing: border-box;
}

.empty-state-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(24, 144, 255, 0.03) 0%, transparent 70%);
  animation: rotate 20s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.empty-state {
  text-align: center;
  position: relative;
  z-index: 1;
  max-width: 500px;
}

.empty-state-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 32px;
}

.empty-state-icon-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 160px;
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.1) 0%, rgba(64, 169, 255, 0.05) 100%);
  border-radius: 50%;
  animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.3;
  }
}

.empty-state-icon {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.empty-state-content {
  margin-bottom: 40px;
}

.empty-state-title {
  font-size: 24px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin: 0 0 12px 0;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.4;
}

.empty-state-description {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.6;
  margin: 0;
}

.empty-state-decoration {
  position: relative;
  height: 60px;
}

.decoration-dot {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  opacity: 0.6;
  animation: bounce 2s ease-in-out infinite;
}

.decoration-dot-1 {
  left: 20%;
  animation-delay: 0s;
}

.decoration-dot-2 {
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 0.3s;
}

.decoration-dot-3 {
  right: 20%;
  animation-delay: 0.6s;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-15px) scale(1.2);
    opacity: 1;
  }
}

/* 响应式优化 */
@media (max-width: 768px) {
  .empty-state-container {
    min-height: calc(100vh - 150px);
    padding: 40px 20px;
  }
  
  .empty-state-icon svg {
    width: 80px;
    height: 80px;
  }
  
  .empty-state-icon-bg {
    width: 120px;
    height: 120px;
  }
  
  .empty-state-title {
    font-size: 20px;
  }
  
  .empty-state-description {
    font-size: 14px;
  }
}
</style>

